import { createFileRoute } from '@tanstack/react-router'
import { MyStatementPage } from '../../../../features/commissions/statement-page'

export const Route = createFileRoute('/_app/commissions/mine/$statementId')({
  staticData: { crumb: 'myCommissionStatement' },
  component: MyStatementPage,
})
